var map = {
	"./auxBattery_degraded.png": 9968,
	"./auxBattery_inoperable.png": 4840,
	"./auxBattery_operative.png": 9932,
	"./brake_on.png": 2997,
	"./gnss_degraded.png": 3727,
	"./gnss_inoperable.png": 3952,
	"./gnss_inoperative.png": 1803,
	"./gnss_operative.png": 8970,
	"./highBeam_on.png": 529,
	"./horn_on.png": 9581,
	"./lowBeam_on.png": 2381,
	"./missing.png": 4279,
	"./positionBeam_on.png": 9222,
	"./radar_degraded.png": 6271,
	"./radar_inoperable.png": 737,
	"./radar_inoperative.png": 5095,
	"./radar_operative.png": 8575,
	"./shield_on.png": 8763,
	"./transparent.png": 7975,
	"./warningTriangle_on.png": 8289,
	"./warning_on.png": 1450
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2918;